import React, { useMemo } from 'react';
import { Route, useLocation, useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import Tabs from './Tabs';
import { FadeSwitch } from '../switches';
import { FullHeightBox } from '../boxes';
import RoundedWhiteBox from '../boxes/RoundedWhiteBox';
import { getTabRouteLocation } from '../../helpers/fingo-paper-tabs';
import { useAvailableHeight, useTabSearch } from '../../hooks';

const FingoPaper = ({ tabs, scrollableTabs, ...props }) => {
  const { path: routePath } = useRouteMatch();
  const location = useLocation();
  const filteredTabs = useMemo(
    () => tabs.filter(({ show, disabled }) => show && !disabled),
    [tabs],
  );
  const hasManyTabs = filteredTabs.length > 1;
  const [height, refChange] = useAvailableHeight();
  const { tabSearch, defaultTabPath } = useTabSearch({ tabs: filteredTabs, persist: true });
  const routeLocation = getTabRouteLocation(location, routePath, defaultTabPath);

  return (
    <FullHeightBox>
      <Tabs tabs={filteredTabs} scrollableTabs={scrollableTabs} tabSearch={tabSearch} />
      <RoundedWhiteBox hasManyOptions={hasManyTabs} height={height} ref={refChange} {...props}>
        <FadeSwitch depth={4} customLocation={routeLocation}>
          {filteredTabs.map(({ id, label, path, component }) => (
            <Route id={id} key={label} path={`${routePath}/${path}`}>
              {component}
            </Route>
          ))}
        </FadeSwitch>
      </RoundedWhiteBox>
    </FullHeightBox>
  );
};

FingoPaper.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.shape()]).isRequired,
      path: PropTypes.string.isRequired,
      component: PropTypes.element.isRequired,
      disabled: PropTypes.bool.isRequired,
      show: PropTypes.bool.isRequired,
      quantity: PropTypes.number,
      preserveSearch: PropTypes.bool,
    }),
  ).isRequired,
  scrollableTabs: PropTypes.bool,
};

FingoPaper.defaultProps = {
  scrollableTabs: false,
};

export default FingoPaper;
